import { NgModule } from '@angular/core';
import { UserDataInteractor } from 'src/app/3.interactor/user.data.interactor';

@NgModule({
    providers: [
        UserDataInteractor
    ]
})
export class AppProviderInteractor { }